(function () {
  "use strict";
  var L = window.Lagom;
  if (!(!L || !L.q)) {
    var q = L.q,
      qa = L.qa,
      motionOff = L.motionOff;
    (function () {
      var list = q("[data-timeline]");
      if (!list) return;
      var steps = qa(".timeline__step", list),
        dots = steps.map(function (st) {
          return q(".timeline__dot", st);
        }),
        end = steps[steps.length - 1],
        burst = !1,
        obs = [],
        passed = [],
        lastKey = "",
        lastStep = -1;
      function measure() {
        var lr = list.getBoundingClientRect(),
          cy = dots.map(function (d) {
            var r = d.getBoundingClientRect();
            return r.top + r.height / 2 - lr.top;
          }),
          y0 = cy[0],
          y1 = cy[cy.length - 1],
          LEN = Math.max(1, y1 - y0),
          still = motionOff(),
          key =
            cy
              .map(function (v) {
                return v.toFixed(1);
              })
              .join(",") + (still ? "S" : "");
        if (key !== lastKey) {
          if (
            ((lastKey = key),
            list.style.setProperty("--tl-top", y0.toFixed(1) + "px"),
            list.style.setProperty("--tl-len", (y1 - y0).toFixed(1) + "px"),
            cy.forEach(function (v, i) {
              list.style.setProperty(
                "--tl-f" + (i + 1),
                ((v - y0) / LEN).toFixed(4),
              );
            }),
            obs.forEach(function (o) {
              o.disconnect();
            }),
            (obs = []),
            still || !window.IntersectionObserver)
          ) {
            (steps.forEach(function (st) {
              st.classList.add("is-passed");
            }),
              setStep(steps.length));
            return;
          }
          dots.forEach(function (d, i) {
            var f = 0.65 - (0.2 * (cy[i] - y0)) / LEN,
              o = new IntersectionObserver(
                function (es) {
                  var e = es[es.length - 1],
                    top = e.rootBounds ? e.rootBounds.top : 0;
                  mark(
                    i,
                    e.isIntersecting || e.boundingClientRect.top < top + 1,
                  );
                },
                {
                  rootMargin:
                    "0px 0px -" + ((1 - f) * 100).toFixed(2) + "% 0px",
                  threshold: 0,
                },
              );
            (o.observe(d), obs.push(o));
          });
        }
      }
      function mark(i, on) {
        if (passed[i] !== on) {
          ((passed[i] = on), steps[i].classList.toggle("is-passed", on));
          for (var n = 0, k = 0; k < steps.length; k++)
            passed[k] && (n = k + 1);
          (setStep(n),
            i === steps.length - 1 &&
              (on && !burst && ((burst = !0), confetti()), on || (burst = !1)));
        }
      }
      function setStep(n) {
        n !== lastStep &&
          ((lastStep = n), list.setAttribute("data-step", String(n)));
      }
      function confetti() {
        var dot = dots[dots.length - 1];
        if (dot.animate) {
          for (
            var colours = [
                "#FFD23F",
                "#FFFFFF",
                "#9FD4FF",
                "#FFE98A",
                "#FF9EC4",
              ],
              i = 0;
            i < 18;
            i++
          ) {
            var piece = document.createElement("span");
            ((piece.className = "tl-confetti"),
              piece.setAttribute("aria-hidden", "true"),
              (piece.style.background = colours[i % colours.length]),
              i % 3 === 0 &&
                ((piece.style.borderRadius = "50%"),
                (piece.style.width = piece.style.height = "5px")),
              dot.appendChild(piece));
            var a = (i / 18) * Math.PI * 2 + Math.random() * 0.35,
              dist = 26 + Math.random() * 30,
              x = Math.cos(a) * dist,
              y = Math.sin(a) * dist,
              spin = (Math.random() * 2 - 1) * 360;
            piece.animate(
              [
                {
                  transform: "translate(-50%, -50%) rotate(0deg) scale(0.6)",
                  opacity: 1,
                },
                {
                  transform:
                    "translate(calc(-50% + " +
                    (x * 0.85).toFixed(1) +
                    "px), calc(-50% + " +
                    (y * 0.85).toFixed(1) +
                    "px)) rotate(" +
                    (spin * 0.6).toFixed(0) +
                    "deg) scale(1)",
                  opacity: 1,
                  offset: 0.55,
                },
                {
                  transform:
                    "translate(calc(-50% + " +
                    x.toFixed(1) +
                    "px), calc(-50% + " +
                    (y + 18).toFixed(1) +
                    "px)) rotate(" +
                    spin.toFixed(0) +
                    "deg) scale(0.9)",
                  opacity: 0,
                },
              ],
              {
                duration: 900 + Math.random() * 300,
                easing: "cubic-bezier(0.2, 0.7, 0.3, 1)",
              },
            ).onfinish = (function (el) {
              return function () {
                el.remove();
              };
            })(piece);
          }
          (end.classList.add("is-celebrating"),
            setTimeout(function () {
              end.classList.remove("is-celebrating");
            }, 600));
        }
      }
      (window.addEventListener("resize", measure),
        window.addEventListener("load", measure),
        document.fonts &&
          document.fonts.ready &&
          document.fonts.ready.then(measure),
        document.addEventListener("lagom:layout", measure),
        window.matchMedia &&
          window
            .matchMedia("(prefers-reduced-motion: reduce)")
            .addEventListener("change", measure),
        measure());
    })();
  }
})();

